import fetch from '@/utils/fetch';
// import filterNull from '@/utils/filterNull';
import { message } from 'antd';

const model = {
  state: {
    businessDistrictList: [], // 生效商圈列表
    businessDistrictId: '', // 当前的商圈id
    groupList: [], // 某个商圈的商家组列表
    groupParams: {
      per_page: 10,
      cur_page: 1,
    },
    groupListTotal: 0,
    nonGroupShopList: [], // 还没有商家组的商家列表
    selectGroup: {}, // 要调整到的商家组
    selectAdjustShop: [], // 当前要调整的商家列表
    currentAdjustGroup: {}, // 当前要调整的商家组信息
    searchGroupShopList: [], // 搜索的商家组的店铺列表
    modalType: 0, // 调整商家组类型弹窗，1为无商家组新建，2为调整商家组内商家
    highlightShopList: [],
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  // eslint-disable-next-line no-unused-vars
  actions: ({ dispatch: { businessGroupManage }, getState }) => ({
    // 获取商圈列表
    async getbusinessDistrictList() {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/authority/cbd/queryCbdList', {
        params: {
          cbdStatus: 1, // 生效
        },
      });
      if (data) {
        const businessDistrictList = data.map((d) => ({
          value: d.businessDistrictId,
          label: d.businessDistrictName,
        }));
        businessGroupManage.setState({ businessDistrictList });
        // 默认选择第一个
        if (businessDistrictList.length > 0) {
          businessGroupManage.setState({ businessDistrictId: businessDistrictList[0].value });
        }
      }
    },
    // 获取商家组列表
    async getGroupList() {
      const params = {
        businessDistrictId: getState().businessGroupManage.businessDistrictId,
      };
      const data = await fetch('/saasmerchant/fsarea/shopGroup/list', {
        params,
      });
      if (data) {
        businessGroupManage.setState({
          groupList: data.list || [],
          nonGroupShopList: data.nonGroupShopList || [],
          groupListTotal: data.total,
        });
      }
    },
    // 商家组分页
    onGroupNav(e) {
      businessGroupManage.setState({
        groupParams: {
          cur_page: e,
          per_page: 10,
        },
      });
      businessGroupManage.getGroupList();
    },
    setSelectGroup(selectGroup) {
      businessGroupManage.setState({
        selectGroup,
      });
    },
    changeBusiness(e) {
      // 改变商圈，清空商家组列表数据，重新set
      businessGroupManage.setState({
        businessDistrictId: e,
        groupParams: {
          per_page: 10,
          cur_page: 1,
        },
        selectAdjustShop: [],
        groupList: [],
        selectGroup: {},
        searchGroupShopList: [],
        nonGroupShopList: [],
        groupListTotal: 0,
      });
    },
    setModalType(type) {
      businessGroupManage.setState({
        modalType: type,
      });
    },
    // 重置商圈商家组
    async reSetDensity(density) {
      const { businessDistrictId } = getState().businessGroupManage;
      const data = await fetch('/saasmerchant/fsarea/shopGroup/reset', {
        type: 'POST',
        params: {
          businessDistrictId,
          density,
        },
        useJson: true,
      });
      if (data) {
        message.success('商家组计算中，预计1分钟后生成');
      }
    },
    checkAdjustShopList(item) {
      // 选中当前要调整的商家
      // console.log('selectAdjustShop', item);
      businessGroupManage.setState({
        selectAdjustShop: item,
      });
    },
    clearRangeData() {
      businessGroupManage.setState({
        selectAdjustShop: [],
      });
    },
    // 重置各种弹窗里面的数据
    clearModalData() {
      businessGroupManage.setState({
        selectAdjustShop: [],
        selectGroup: {},
        searchGroupShopList: [],
        density: 500,
        currentAdjustGroup: {},
      });
    },
    async adjustBusiness() {
      const { selectGroup, selectAdjustShop, businessDistrictId, modalType, currentAdjustGroup } =
        getState().businessGroupManage;
      const shopList = selectAdjustShop.map((item) => {
        if (modalType === 1) {
          return { shopId: item.shopId, subShopId: item.subShopId };
        }
        const shopId = item.key.split('-')[0];
        const subShopId = item.key.split('-')[1];
        return { shopId, subShopId };
      });
      if (selectGroup.type === 1 && modalType === 1) {
        // 新增商家组
        const data = await fetch('/saasmerchant/fsarea/shopGroup/create', {
          type: 'POST',
          params: {
            shopGroupName: selectGroup.shopGroupName,
            shopList,
            businessDistrictId,
          },
          useJson: true,
        });
      } else {
        // 调整商家组
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const data = await fetch('/saasmerchant/fsarea/shopGroup/modify', {
          type: 'POST',
          params: {
            shopList,
            businessDistrictId,
            newShopGroupName: selectGroup.type === 1 ? selectGroup.shopGroupName : '', // 新创建的商家组名称, selectGroup.type === 1为新建商家
            exchangeShopGroupId: selectGroup.type === 1 ? 0 : selectGroup.shopGroupId, // 调整到对应的商家组id,新建的商家组商家组传0
            currentShopGroupId: currentAdjustGroup.groupId || selectGroup.shopGroupId, // 当前商家组id，无商家组商店传0
            currentShopGroupName: currentAdjustGroup.groupName || '', // 当前商家组名称
          },
          useJson: true,
        });
      }
      businessGroupManage.getGroupList();
    },
    async searchGroupShop(name) {
      if (!name) {
        businessGroupManage.setState({
          searchGroupShopList: [],
        });
        return;
      }
      const { currentAdjustGroup } = getState().businessGroupManage;
      const searchShopList = await fetch('/saasmerchant/fsarea/shopGroup/searchShop', {
        params: {
          shopGroupId: currentAdjustGroup.groupId,
          shopName: name,
        },
      });
      businessGroupManage.setState({
        searchGroupShopList: searchShopList || [],
      });
    },
    initSearchGroupShopList() {
      const { shopList } = getState().businessGroupManage.currentAdjustGroup;
      businessGroupManage.setState({
        searchGroupShopList: shopList || [],
      });
    },
    setCurrentAdjustGroup(group) {
      businessGroupManage.setState({
        currentAdjustGroup: group,
      });
    },
    async setAllocateConfig(values) {
      const { currentAdjustGroup } = getState().businessGroupManage;
      const { fsDeliveryShopList } = values;
      const fsDeliveryShopListTemp = fsDeliveryShopList.map((item) => {
        const shopId = item.split('-')[0];
        const subShopId = item.split('-')[1];
        return {
          shopId,
          subShopId,
        };
      });
      const data = await fetch('/saasmerchant/fsarea/shopGroup/allocateConfig', {
        type: 'POST',
        params: {
          shopGroupId: currentAdjustGroup.groupId,
          overflowTransOrder: values.overflowTransOrder,
          fsDeliveryShopList: JSON.stringify(fsDeliveryShopListTemp),
        },
        useJson: true,
      });
      if (data) {
        message.success('成功');
      } else {
        message.error('失败');
      }
    },
  }),
};

export default model;
